import axios from 'axios'

const PostingServince = {
  async get (params = {}) {
    return axios.get('po/inter-branch-transfer/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/inter-branch-transfer/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`po/inter-branch-transfer/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-branch-transfer/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-branch-transfer/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-branch-transfer/postings/${data.id}`, { data })
  }
}

export default PostingServince
